import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { PassportAdminService } from './Services/passport.admin.service';
import { TenantService } from '../../../Services/tenant.service';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';


@Component({
    selector: 'my-package',
    templateUrl: './passport.component.html',
    styleUrls: ['./passport.component.css'],
    standalone: true,
    imports: [MatSidenavContainer, MatSidenav, MatNavList, MatListItem, RouterLink, RouterLinkActive, RouterOutlet]
})
export class PassportComponent implements OnInit {

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private service: PassportAdminService,
    private tenantService: TenantService) {

    }

    ngOnInit(): void {
        //var tenantId = this.activatedRoute.snapshot.parent.params["tenantId"];
        //if ((!this.tenantService.selectedTenant || this.tenantService.selectedTenant.Value === "-1")) {
        //    this.tenantService.attemptToBindTenant(tenantId)
        //        .then(null, r => this.router.navigate(["/"]));
        //}
    }
}
